import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { useDarkMode } from "../components/DarkModeContext";
import { FaSun, FaMoon } from "react-icons/fa";

const navigation = [
  { name: "Home", href: "/home", current: false },
  { name: "Background", href: "/pre-phd", current: false },
];

const Sidebar = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const selected = props.page;
  const { darkMode, setDarkMode } = useDarkMode();

  navigation.forEach((item) => {
    item.current = item.name === selected;
  });

  return (
    <header className="w-full border-b border-gray-200/80 dark:border-gray-800/80 bg-lightBg/95 dark:bg-darkBg/95 backdrop-blur sticky top-0 z-40">
      <div className="mx-auto flex w-full max-w-6xl items-center gap-3 px-4 py-2.5 sm:px-6 lg:px-8">
        <nav className="hidden lg:flex flex-1 items-center justify-center gap-1">
          {navigation.map((item) => (
            <Link
              to={item.href}
              key={item.name}
              className={`px-2.5 py-1.5 rounded-md text-sm transition-colors ${
                item.current
                  ? "text-green dark:text-green-dark font-semibold"
                  : "text-lightText dark:text-darkText hover:text-green dark:hover:text-green-dark"
              }`}
              aria-current={item.current ? "page" : undefined}
            >
              {item.name}
            </Link>
          ))}
        </nav>

        <button
          onClick={() => setDarkMode(!darkMode)}
          className="p-2 rounded-md text-lightText dark:text-darkText hover:text-green dark:hover:text-green-dark lg:ml-auto"
          aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
        >
          {darkMode ? <FaSun size={20} /> : <FaMoon size={20} />}
        </button>

        <button
          onClick={() => setIsOpen(!isOpen)}
          className="text-lightText dark:text-darkText p-2 lg:hidden ml-auto"
          aria-label={isOpen ? "Close menu" : "Open menu"}
        >
          {isOpen ? <AiOutlineClose size={24} /> : <AiOutlineMenu size={24} />}
        </button>
      </div>

      <div className={`${isOpen ? "block" : "hidden"} lg:hidden px-4 sm:px-5 pb-2.5`}>
        <nav className="border-t border-gray-200/80 dark:border-gray-800/80 pt-2.5 space-y-1">
          {navigation.map((item) => (
            <Link to={item.href} key={item.name} className="block">
              <span
                className={`block py-1.5 px-2.5 rounded-md text-left text-sm ${
                  item.current
                    ? "text-green dark:text-green-dark font-semibold"
                    : "text-lightText dark:text-darkText hover:text-green dark:hover:text-green-dark"
                }`}
                aria-current={item.current ? "page" : undefined}
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </span>
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Sidebar;
